/* 处理权限对应 */
import store from '@/store'
import ZhulogicModule from '../../../zhulogic-module/packages/index';

export function permissionFuc(identifier, event = null, olnyList = null) {
    let lists = [];
    if (!olnyList) {
        lists = store.state.permission;
    } else {
        olnyList.forEach((item, index) => {
            if (item.childPermission && item.childPermission.length > 0) {
                item.childPermission.forEach(ele => {
                    lists.push(ele.permission)
                })
            }
        });
    }

    if (lists && lists.length > 0) {
        if (!identifier) {
            return false;
        }
        if (lists.indexOf(identifier) > -1) {
            return true;
        } else {
            if (event === 'click') {
                ZhulogicModule.Message.error('您没有权限查看，请联系管理员');
            }
            return false;
        }
        return true;

    } else {
        return true;
    }

}